import { cn, TextField } from "kz-ui-sdk";
import { forwardRef, useState } from "react";
import { MdLock, MdVisibility, MdVisibilityOff } from "react-icons/md";

type TextFieldProps = React.ComponentProps<typeof TextField>;

interface PasswordTextFieldProps extends Omit<TextFieldProps, "type" | "icon"> {
  showPasswordIcon?: boolean;
  buttonClass?: string;
}

const PasswordTextField = forwardRef<HTMLInputElement, PasswordTextFieldProps>((props: PasswordTextFieldProps, ref) => {
  const { showPasswordIcon = true, buttonClass, classes, ...rest } = props;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <TextField
        {...rest}
        type={showPassword ? "text" : "password"}
        icon={<MdLock className="text-2xl text-content-base" />}
        classes={{
          "input&": "w-full pr-10",
          "iconContainer&": "!left-3 !top-[13px]",
          ...classes,
        }}
        ref={ref}
      />
      {showPasswordIcon && (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className={cn("absolute top-[13px] right-3 text-content-base", buttonClass)}
        >
          {showPassword ? <MdVisibility className="text-2xl" /> : <MdVisibilityOff className="text-2xl" />}
        </button>
      )}
    </div>
  );
});

PasswordTextField.displayName = "PasswordTextField";

export default PasswordTextField;
